import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <path d="M6 7h.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="2" y="13" width="20" height="8" rx="2" />
    <path d="M6 17h.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="2" y="3" width="20" height="8" rx="2" />
  </svg>
);
